import MicroModal from 'micromodal';
import $ from 'cash-dom';
import {
    format
} from 'date-fns';
import LuckyWheel from './game/canvas';
import initPopup from './popup';
import EventBus from './event';

function WoayGame(selector, Options) {
    const eventBus = new EventBus();
    let theWheel = LuckyWheel(selector, Options, eventBus);
    function checkSpinning() {
        if (theWheel.isSpinning()) {
            vanillaToast.warning('Vòng quay đang quay, vui lòng đợi trong giây lát', {
                duration: 1000,
                fadeDuration: 200
            })
            return true;
        }
    }

    function redraw(opts) {
        theWheel = LuckyWheel(selector, opts, eventBus);
    }

    return {
        $,
        redraw,
        rollToSku: theWheel.rollToSku,
        checkSpinning,
        theWheel,
        format,
        eventBus
    }
}
WoayGame.$ = $;
WoayGame.initPopup = initPopup;
window.WoayGame = WoayGame;
window.MicroModal = MicroModal;